import { j as s } from "../../jsx-runtime-Wav_3Wde.js";
import e from "../BaseIcon.mjs";
const r = (o) => /* @__PURE__ */ s.jsx("svg", {
  viewBox: "0 0 24 24",
  "aria-label": "Opens modal",
  ...o,
  children: /* @__PURE__ */ s.jsxs("g", {
    children: [
      /* @__PURE__ */ s.jsx("rect", {
        x: "11",
        y: "8",
        width: "5",
        height: "5"
      }),
      /* @__PURE__ */ s.jsx("path", {
        d: "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M14.5,17.5H8H6.5V16    V9.5H8V16h6.5V17.5z M17.5,8v5v1.5H16h-5H9.5V13V8V6.5H11h5h1.5V8z"
      })
    ]
  })
}), c = (o) => /* @__PURE__ */ s.jsx(e, {
  IconSvg: r,
  ...o
});
export {
  c as default
};
